module.exports = __webpack_public_path__ + "static/media/0323_IMG_FE_LES_ENSEIGNES_LES_FROMAGES_LETTRE_A_LETTRE.093bd8a0.webp";